import { Link } from "react-router-dom";

const DATENSCHUTZ = [
  {
    titel: "Einleitung",
    zeilen: [
      "Mit diesen Datenschutzhinweisen informieren wir Sie über unseren Umgang mit Ihren personenbezogenen Daten und über Ihre Rechte nach der Europäischen Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz (BDSG). Verantwortlich für die Datenverarbeitung ist die 2besales GmbH (nachfolgend als „wir“ oder „uns“ bezeichnet)."
    ]
  },
  {
    titel: "I. Allgemeine Angaben",
    zeilen: []
  },
  {
    titel: "1. Kontakt",
    ebene: 2,
    zeilen: [
      "Wenn Sie Fragen oder Anregungen zu diesen Informationen haben oder sich wegen der Geltendmachung Ihrer Rechte an uns wenden möchten, richten Sie Ihre Anfrage bitte an:",
      "Patrick Häfner",
      "2besales GmbH",
      "Lena-Christ-Str. 2",
      "82031 Grünwald",
      "Deutschland",
      "Tel.: +49 89 540489383",
      "E-Mail: info@2besales.de"
    ]
  },
  {
    titel: "2. Rechtsgrundlagen",
    ebene: 2,
    zeilen: [
      "Der datenschutzrechtliche Begriff personenbezogene Daten bezeichnet alle Informationen, die sich auf einen bestimmten oder bestimmbaren Menschen beziehen. Wir verarbeiten personenbezogene Daten unter Beachtung der einschlägigen Datenschutzvorschriften, insbesondere der DSGVO und des BDSG. Eine Datenverarbeitung durch uns findet nur auf der Grundlage einer gesetzlichen Erlaubnis statt. Wir verarbeiten personenbezogene Daten nur:",
      "– mit Ihrer Einwilligung (Art. 6 Abs. 1 Buchst. a DSGVO),",
      "– zur Erfüllung eines Vertrags, dessen Vertragspartei Sie sind, oder auf Ihre Anfrage zur Durchführung vorvertraglicher Maßnahmen (Art. 6 Abs. 1 Buchst. b DSGVO),",
      "– zur Erfüllung einer rechtlichen Verpflichtung (Art. 6 Abs. 1 Buchst. c DSGVO), oder",
      "– wenn die Verarbeitung zur Wahrung unserer berechtigten Interessen oder der berechtigten Interessen eines Dritten erforderlich ist (Art. 6 Abs. 1 Buchst. f DSGVO)."
    ]
  },
  {
    titel: "3. Dauer der Speicherung",
    ebene: 2,
    zeilen: [
      "Sofern sich aus den folgenden Hinweisen nichts anderes ergibt, speichern wir die Daten nur solange, wie es zur Erreichung des Verarbeitungszwecks oder für die Erfüllung unserer vertraglichen oder gesetzlichen Pflichten erforderlich ist. Solche gesetzlichen Aufbewahrungspflichten können sich insbesondere aus handels- oder steuerrechtlichen Vorschriften ergeben.",
      "Ab dem Schluss des Kalenderjahres, in dem die Daten erhoben wurden, werden wir personenbezogene Daten in unseren Buchhaltungsdaten für zehn Jahre sowie personenbezogene Daten in Handelsbriefen und Verträgen für sechs Jahre aufbewahren. Im Übrigen werden wir Daten im Zusammenhang mit nachweispflichtigen Einwilligungen sowie mit Reklamations- und Forderungsansprüchen für die Dauer der gesetzlichen Verjährungsfristen aufbewahren."
    ]
  },
  {
    titel: "4. Kategorien von Empfängern der Daten",
    ebene: 2,
    zeilen: [
      "Wir setzen im Rahmen der Verarbeitung Ihrer Daten Auftragsverarbeiter ein. Zu den durch solche Auftragsverarbeiter ausgeführten Verarbeitungsvorgängen gehören z. B. Hosting, Wartung und Support von IT-Systemen, CRM-Verwaltung, Marketingmaßnahmen sowie Buchhaltung und Abrechnung. Im Übrigen übermitteln wir Ihre personenbezogenen Daten ggf. an Post- und Zustelldienste, unsere Hausbank, Steuerberater/Wirtschaftsprüfer oder die Finanzverwaltung."
    ]
  },
  {
    titel: "5. Datenübermittlung in Drittländer",
    ebene: 2,
    zeilen: [
      "Der Besuch unserer Website sowie die Nutzung der von uns eingesetzten Dienste kann mit der Übermittlung bestimmter personenbezogener Daten in Drittländer verbunden sein. Eine solche Übermittlung erfolgt in zulässiger Weise, wenn die Europäische Kommission ein angemessenes Datenschutzniveau festgestellt hat oder geeignete Garantien gem. Art. 46 DSGVO vorliegen. Sofern im Folgenden nichts anderes angegeben, verwenden wir als geeignete Garantien die EU-Standardvertragsklauseln."
    ]
  },
  {
    titel: "6. Ihre Rechte",
    ebene: 2,
    zeilen: [
      "Als betroffene Person haben Sie insbesondere folgende Rechte:",
      "– Auskunftsrecht (Art. 15 DSGVO, § 34 BDSG)",
      "– Recht auf Berichtigung (Art. 16 DSGVO)",
      "– Recht auf Löschung (Art. 17 DSGVO, § 35 BDSG)",
      "– Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)",
      "– Recht auf Datenübertragbarkeit (Art. 20 DSGVO)",
      "– Widerrufsrecht bei Einwilligung (Art. 7 Abs. 3 DSGVO)",
      "– Beschwerderecht bei einer Aufsichtsbehörde (Art. 77 DSGVO)"
    ]
  },
  {
    titel: "7. Widerspruchsrecht",
    ebene: 2,
    zeilen: [
      "Sie haben nach Art. 21 Abs. 1 DSGVO das Recht, gegen Verarbeitungen auf Grundlage von Art. 6 Abs. 1 Buchst. e oder f DSGVO Widerspruch einzulegen. Sofern wir personenbezogene Daten zum Zweck der Direktwerbung verarbeiten, können Sie dieser Verarbeitung gem. Art. 21 Abs. 2 und 3 DSGVO jederzeit widersprechen."
    ]
  },
  {
    titel: "II. Datenverarbeitungen auf unserer Website",
    zeilen: []
  },
  {
    titel: "1. Verarbeitung von Server-Log-Files",
    ebene: 2,
    zeilen: [
      "Bei der rein informativen Nutzung unserer Website werden automatisch allgemeine Informationen gespeichert, die Ihr Browser an unseren Server übermittelt (z. B. Browsertyp, Betriebssystem, aufgerufene Seite, IP-Adresse, Datum und Uhrzeit). Die Verarbeitung dient der technischen Verwaltung und Sicherheit der Website und beruht auf Art. 6 Abs. 1 Buchst. f DSGVO. Die gespeicherten Daten werden nach sieben Tagen gelöscht."
    ]
  },
  {
    titel: "2. Cookies",
    ebene: 2,
    zeilen: [
      "Wir verwenden auf unserer Website Cookies und vergleichbare Technologien. Technisch notwendige Cookies werden ohne Einwilligung gesetzt. Nicht technisch notwendige Cookies (z. B. für Analyse- und Marketingzwecke) setzen wir nur mit Ihrer Einwilligung gem. Art. 6 Abs. 1 Buchst. a DSGVO. Hinweise zu den einzelnen Cookies finden Sie im Cookie-Banner dieser Seite."
    ]
  },
  {
    titel: "3. Consent Management",
    ebene: 2,
    zeilen: [
      "Diese Website verwendet einen Cookie-Banner zur Steuerung von Cookies und zur Dokumentation Ihrer Einwilligung. Die Rechtsgrundlage für die Dokumentation ist Art. 6 Abs. 1 Buchst. c DSGVO i. V. m. Art. 7 Abs. 1 DSGVO. Sie können Ihre Einwilligung jederzeit über den Link „Cookie-Einstellungen“ im Footer dieser Seite anpassen oder widerrufen."
    ]
  },
  {
    titel: "4. Kontaktmöglichkeiten und Anfragen",
    ebene: 2,
    zeilen: [
      "Unsere Website enthält Kontaktformulare, über die Sie uns Nachrichten schicken können. Die Übertragung erfolgt verschlüsselt. Wir verarbeiten die angegebenen Daten zum Zweck der Bearbeitung Ihrer Anfrage. Rechtsgrundlage ist Art. 6 Abs. 1 Buchst. b DSGVO (bei vertragsbezogenen Anfragen) bzw. Art. 6 Abs. 1 Buchst. f DSGVO (bei sonstigen Anfragen)."
    ]
  },
  {
    titel: "5. Online-Shop / Workshop-Buchungen",
    ebene: 2,
    zeilen: [
      "Soweit Sie ein Produkt bestellen oder sich zu einem Workshop anmelden, verarbeiten wir die von Ihnen angegebenen Daten ausschließlich zur Vertragsabwicklung auf Grundlage von Art. 6 Abs. 1 Buchst. b DSGVO."
    ]
  },
  {
    titel: "6. Meta Pixel / Facebook Ads",
    ebene: 2,
    zeilen: [
      "Wir setzen den Meta Pixel des Anbieters Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland (“Meta”) ein. Der Meta Pixel ist ein JavaScript-Code-Snippet, das es uns ermöglicht, die Aktionen von Besuchern auf unserer Website zu verfolgen, nachdem diese eine Facebook- oder Instagram-Werbeanzeige gesehen oder darauf geklickt haben.",
      "Dabei werden u. a. folgende Daten erhoben und an Meta übertragen: IP-Adresse, Browser-Informationen, Seitenaufrufe sowie Conversion-Ereignisse (z. B. Kontaktanfragen). Meta kann diese Daten mit Ihrem Facebook-Profil verknüpfen, sofern Sie bei Facebook eingeloggt sind. Die Daten können in die USA übermittelt werden; die Rechtsgrundlage bilden die EU-Standardvertragsklauseln.",
      "Rechtsgrundlage für den Einsatz des Meta Pixels ist Ihre Einwilligung gem. Art. 6 Abs. 1 Buchst. a DSGVO. Sie können Ihre Einwilligung jederzeit über unser Consent-Management-Tool widerrufen.",
      "Weitere Informationen finden Sie in der Datenschutzrichtlinie von Meta: https://www.facebook.com/privacy/explanation"
    ]
  },
  {
    titel: "7. Calendly",
    ebene: 2,
    zeilen: [
      "Für die Terminbuchung nutzen wir Calendly des Anbieters Calendly LLC, 271 17th St NW, 10th Floor, Atlanta, Georgia 30363, USA. Wenn Sie über Calendly einen Termin mit uns vereinbaren, werden die von Ihnen eingegebenen Daten (z. B. Name, E-Mail-Adresse, ggf. weitere Angaben) an Calendly übertragen und dort gespeichert. Die Daten werden in die USA übertragen; die Rechtsgrundlage bilden die EU-Standardvertragsklauseln. Mit Calendly haben wir einen Auftragsverarbeitungsvertrag (AVV) gem. Art. 28 DSGVO abgeschlossen.",
      "Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 Buchst. b DSGVO (Durchführung vorvertraglicher Maßnahmen) sowie Art. 6 Abs. 1 Buchst. f DSGVO (berechtigtes Interesse an einer effizienten Terminverwaltung).",
      "Weitere Informationen: https://calendly.com/privacy"
    ]
  },
  {
    titel: "8. Claude (Anthropic)",
    ebene: 2,
    zeilen: [
      "Wir setzen Claude, ein KI-Sprachmodell des Anbieters Anthropic PBC, 548 Market St, PMB 90375, San Francisco, CA 94104, USA, ein. Auf dieser Landingpage dient Claude der automatischen Erst-Einschätzung der Zielgruppen-Angaben aus unserem Anfrageformular.",
      "Soweit bei der Nutzung von Claude personenbezogene Daten (z. B. Inhalte aus Kundenkommunikation oder Projektdaten) verarbeitet werden, erfolgt dies auf Grundlage unseres berechtigten Interesses an effizienten Arbeitsprozessen (Art. 6 Abs. 1 Buchst. f DSGVO) bzw. auf Grundlage einer Einwilligung (Art. 6 Abs. 1 Buchst. a DSGVO). Mit Anthropic haben wir einen Auftragsverarbeitungsvertrag (AVV) gem. Art. 28 DSGVO abgeschlossen. Daten können in die USA übertragen werden; die Rechtsgrundlage bilden die EU-Standardvertragsklauseln.",
      "Wir weisen darauf hin, dass wir bei der Nutzung von Claude keine besonderen Kategorien personenbezogener Daten (Art. 9 DSGVO) eingeben und keine Daten eingeben, die eine direkte Identifizierung von Personen ermöglichen, sofern dies nicht ausdrücklich für die jeweilige Aufgabe erforderlich ist.",
      "Weitere Informationen finden Sie in der Datenschutzrichtlinie von Anthropic: https://www.anthropic.com/privacy"
    ]
  },
  {
    titel: "9. Dienste und Inhalte Dritter",
    ebene: 2,
    zeilen: [
      "Wir binden auf unserer Website Inhalte und Dienste von Drittanbietern ein, was die Übermittlung Ihrer IP-Adresse an die jeweiligen Anbieter technisch erfordert. Diese Verarbeitungen erfolgen auf Grundlage von Art. 6 Abs. 1 Buchst. f DSGVO."
    ]
  },
  {
    titel: "III. Datenverarbeitungen auf unseren Social-Media-Seiten",
    zeilen: [
      "Wir sind auf mehreren Social-Media-Plattformen mit einer Unternehmensseite vertreten (Facebook, Instagram, LinkedIn), um weitere Informations- und Kommunikationsmöglichkeiten zu bieten."
    ]
  },
  {
    titel: "1. Facebook- und Instagram-Seite",
    ebene: 2,
    zeilen: [
      "Allein Verantwortlicher für die Verarbeitung personenbezogener Daten beim Besuch unserer Facebook- oder Instagram-Seite ist grundsätzlich Meta Platforms Ireland Limited. Darüber hinaus verarbeiten wir und Meta als gemeinsam Verantwortliche anonymisierte Seiten-Statistiken (“Seiten-Insights”). Rechtsgrundlage ist Art. 6 Abs. 1 Buchst. f DSGVO.",
      "Weitere Informationen und Opt-out-Möglichkeiten: https://www.facebook.com/privacy/explanation"
    ]
  },
  {
    titel: "2. LinkedIn-Unternehmensseite",
    ebene: 2,
    zeilen: [
      "Für den Besuch unserer LinkedIn-Seite ist grundsätzlich LinkedIn Ireland Unlimited Company allein Verantwortliche. Im Rahmen der Seiten-Insights verarbeiten wir und LinkedIn als gemeinsam Verantwortliche anonymisierte Statistiken. Rechtsgrundlage ist Art. 6 Abs. 1 Buchst. f DSGVO.",
      "Wir haben mit LinkedIn eine Vereinbarung über die gemeinsame Verantwortlichkeit abgeschlossen (abrufbar unter: https://legal.linkedin.com/pages-joint-controller-addendum). LinkedIn ist dafür verantwortlich, es Ihnen zu ermöglichen, Ihre DSGVO-Rechte auszuüben."
    ]
  },
  {
    titel: "3. Kommentare und Direktnachrichten",
    ebene: 2,
    zeilen: [
      "Informationen, die Sie uns über unsere Social-Media-Seiten mitteilen (z. B. Kommentare, Direktnachrichten), verarbeiten wir als allein Verantwortlicher auf Grundlage von Art. 6 Abs. 1 Buchst. f DSGVO, um mit anfragenden Personen in Kontakt zu treten."
    ]
  },
  {
    titel: "IV. Weitere Datenverarbeitungen",
    zeilen: []
  },
  {
    titel: "1. Kunden- und Interessentendaten",
    ebene: 2,
    zeilen: [
      "Wenn Sie als Kunde oder Interessent mit uns in Kontakt treten, verarbeiten wir Ihre Daten zur Begründung oder Durchführung der Vertragsbeziehung auf Grundlage von Art. 6 Abs. 1 Buchst. b DSGVO. Darüber hinaus verarbeiten wir Kunden- und Interessentendaten zu Auswertungs- und Marketingzwecken auf Grundlage von Art. 6 Abs. 1 Buchst. f DSGVO."
    ]
  },
  {
    titel: "2. Auftragsverarbeitungsverträge (AVV)",
    ebene: 2,
    zeilen: [
      "Mit allen Dienstleistern, die in unserem Auftrag personenbezogene Daten verarbeiten, haben wir Auftragsverarbeitungsverträge gem. Art. 28 DSGVO abgeschlossen. Dies gilt insbesondere für:",
      "– Calendly LLC (Terminbuchung)",
      "– Anthropic PBC (KI-Sprachmodell Claude)",
      "Durch die AVVs ist sichergestellt, dass diese Dienstleister personenbezogene Daten nur nach unseren dokumentierten Weisungen verarbeiten und geeignete technische und organisatorische Maßnahmen zum Schutz der Daten implementiert haben."
    ]
  },
  {
    titel: "3. Verwendung der E-Mail-Adresse zu Marketingzwecken",
    ebene: 2,
    zeilen: [
      "Wir können Ihre bei Registrierung oder Bestellung angegebene E-Mail-Adresse verwenden, um Sie über eigene ähnliche Produkte und Leistungen zu informieren. Rechtsgrundlage ist Art. 6 Abs. 1 Buchst. f DSGVO i. V. m. § 7 Abs. 3 UWG. Sie können dem jederzeit widersprechen, ohne dass hierfür andere als die Übermittlungskosten nach den Basistarifen entstehen — per Klick auf den Abmeldelink in jedem Mailing oder per E-Mail an info@2besales.de."
    ]
  },
  {
    titel: "Fotos",
    zeilen: [
      "Julia Mittelhamm",
      "Johann-Fischer-Str. 11",
      "69121 Heidelberg",
      "Deutschland",
      "Telefon: +49 171 5817752",
      "E-Mail: info@juliamittelhamm.com",
      "Web: www.juliamittelhamm.com"
    ]
  }
];

const IMPRESSUM = [
  {
    titel: "Angaben gemäß § 5 TMG",
    zeilen: [
      "2besales GmbH",
      "Lena-Christ-Str. 2",
      "82031 Grünwald",
      "Telefon: 089 540489383",
      "Handelsregister B des Amtsgerichts München: HRB 293569",
      "Vertreten durch:",
      "Patrick Häfner (Geschäftsführer)"
    ]
  },
  {
    titel: "Kontakt",
    zeilen: ["E-Mail: info@2besales.de"]
  },
  {
    titel: "Umsatzsteuer-ID",
    zeilen: ["Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE368739520"]
  },
  {
    titel: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
    zeilen: ["Patrick Häfner", "E-Mail: info@2besales.de"]
  },
  {
    titel: "Datenschutzbeauftragter",
    zeilen: [
      "Patrick Häfner",
      "Lena-Christ-Str. 2",
      "82031 Grünwald",
      "Telefon: 089 540489383",
      "E-Mail: info@2besales.de"
    ]
  },
  {
    titel: "Streitschlichtung",
    zeilen: [
      "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Unsere E-Mail-Adresse finden Sie oben im Impressum.",
      "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen."
    ]
  },
  {
    titel: "Haftung für Inhalte",
    zeilen: [
      "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
      "Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen."
    ]
  },
  {
    titel: "Haftung für Links",
    zeilen: [
      "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.",
      "Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen."
    ]
  },
  {
    titel: "Urheberrecht",
    zeilen: [
      "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.",
      "Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen."
    ]
  }
];

export default function Rechtliches({ art }) {
  const titel = art === "impressum" ? "Impressum" : "Datenschutzerklärung";
  const abschnitte = art === "impressum" ? IMPRESSUM : DATENSCHUTZ;
  return (
    <main className="min-h-screen bg-white px-5 py-20">
      <div className="mx-auto max-w-2xl">
        <h1 className="text-3xl font-semibold text-textdunkel" data-testid="rechtliches-ueberschrift">
          {titel}
        </h1>
        {abschnitte.map((a, i) => (
          <section key={`${a.titel}-${i}`} className={a.ebene === 2 ? "mt-8" : "mt-12"} data-testid={`rechtliches-abschnitt-${i + 1}`}>
            {a.ebene === 2 ? (
              <h3 className="text-sm font-semibold text-textdunkel">{a.titel}</h3>
            ) : (
              <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-textgrau">{a.titel}</h2>
            )}
            <div className="mt-3 space-y-2">
              {a.zeilen.map((z, j) => (
                <p key={j} className="text-sm leading-[1.8] text-textdunkel">{z}</p>
              ))}
            </div>
          </section>
        ))}
        {art === "impressum" && (
          <p className="mt-12 border-t border-navy/10 pt-6 text-xs leading-[1.8] text-textgrau">
            Diese Website wurde designt und entwickelt von der Website-Agentur (eine Marke der Münchener Marketing Gruppe).
          </p>
        )}
        <Link
          to="/"
          data-testid="rechtliches-zurueck"
          className="mt-12 inline-block text-sm font-medium text-navy transition-colors hover:text-textdunkel"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </main>
  );
}
